export const BODEGA = {
    codigo: "52001000",
    empresa: "NARINO SOUVENIRS S.A.S",
    nombre: "Luis",
    apellido: "Ponce",
    correo: "hola@narinosouvenirs.com",
    celular: "3183270023",
    direccion: "carrera 25 # 18-45",
    adicional: "Local Comercial",
    calle: "Carrera 25",
    referencia: "N/A",
    ciudad: "Pasto",
    cc: "901702737-0",
    departamento: "Nariño"
}

export const NOMBREPEDIDO = 'Pedido Nariño Souvenirs'

export const PESODEFOULT = 500
export const ALTODEFOULT = 25
export const LARGODEFAULT = 20
export const FONDODEFAULT = 10